import { showAlertDialog } from '@juvare/common-web-ui/DialogHelper';
import React from 'react';
import { FileHistoryTable } from '../../features/file-manager';
export function showHistoryDialog(params) {
    showAlertDialog({
        content: (React.createElement(FileHistoryTable, { entityId: params.entityId, currentVersionId: params.currentVersionId, fileName: params.fileName, onBackToFiles: () => {
                params.onBackToFiles();
            } })),
        title: 'History',
        maxWidth: 'lg',
    });
}
